import React from 'react'
import CognitoUserDetail from './abstract/CognitoUserDetail'
import AWSAPI from '../../../common/AWSAPI'
import Config from '../../../Config'

class CompanyDetail extends CognitoUserDetail {
  constructor (props) {
    super(props)
    this.state = {userDetail: ''}
    this.apiUrl = Config.companyAdminApiUrl.selfUser
    this.nameTitle = '企業名'
    this.userRoleName = '企業'
    this.userRoleUrl = 'company'
    this.userRole = 'companyAdmin'
  }
  componentWillMount () {
    const id = AWSAPI.getCurrentUserId('companyAdmin')
    this.loadUserDetail(id)
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'back':
        this.props.history.push('/company_admin/routine_task_home')
        break
      case 'edit':
        this.props.history.push('/company_admin/company/edit')
        break
      default:
        break
    }
  }
  renderPageMenu (state) {
    return (
      <ul className='nav nav-pills'>
        <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back', e)} ><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
        <li className='kw-btn-area'><button id='edit-button' rel='tooltip' title='編集' data-placement='bottom' className='kw-btn-success' onClick={(e) => this.onPageMenuClicked('edit', e)} ><i className='icon-edit icon-large' /><span>編集</span></button></li>
      </ul>
    )
  }
}

export default CompanyDetail



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/CompanyDetail.js